import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Navbar from "../components/Navbar";
import CaseReviewDetails from "../components/CaseReviewDetails";
import CaseReviewNavbar from "../components/CaseReviewNavbar";
import DoctorTranscriptionSection from "../components/DoctorTranscriptionSection";
import DoctorRecordingControls from "../components/DoctorRecordingControls";
import FooterSection from "../components/FooterSection";
import DiscourseAnalysisReport from "../components/DiscourseAnalysisReport";
import useVoiceDuration from "../DurationTimer";
import { RadialBarChart, RadialBar, Legend, ResponsiveContainer, PolarAngleAxis } from 'recharts';
import whisperService from '../services/whisperService';
import bhashiniService from '../services/bhashiniService';
import { saveConsultationSession, formatConsultationData, extractSpeciality, extractCaseType } from '../utils/consultationUtils';
import DashboardHeader from "../components/DashboardHeader";
import { toast } from "react-toastify";

import Swal from "sweetalert2";

function ConsultationPrompt({ name }) {
  const [matchedSuggestions, setMatchedSuggestions] = useState([]);
  const [showSummary, setShowSummary] = useState(false);
  const hasAnalyzedRef = useRef(false);

  const [highlightWords, setHighlightWords] = useState([]);
  const [totalWords, setTotalWords] = useState(0);
  const [totalStigmatizingWords, setTotalStigmatizingWords] = useState(0);

  const [stigma2Terms, setStigma2Terms] = useState([]);
  const [allStigmatizingTerms, setAllStigmatizingTerms] = useState([]);

  const [matchedStigmatizingTerms, setMatchedStigmatizingTerms] = useState([]);
  const [stigmatizingTerms, setStigmatizingTerms] = useState([]);
  const [empathySummary, setEmpathySummary] = useState({ tone: "", redFlags: [], score: 0 });

  const [isMuted, setIsMuted] = useState(false);
  const [isCallEnded, setIsCallEnded] = useState(false);

  const isCallEndedRef = useRef(false);
  const isMutedRef = useRef(false);

  const [consultationData, setConsultationData] = useState("")

  useEffect(() => {
    isMutedRef.current = isMuted;
  }, [isMuted]);

  useEffect(() => {
    isCallEndedRef.current = isCallEnded;
  }, [isCallEnded]);

  const toggleMute = () => {
    setIsMuted((prev) => !prev);
  };

  console.log("consultationData", consultationData)

  const { voiceDuration, startTimer, stopTimer } = useVoiceDuration();
  const formattedSpokenTime = `${voiceDuration.minutes}m ${voiceDuration.seconds}s`;
  const spokenTimeWarning =
    voiceDuration.minutes === 0 && voiceDuration.seconds < 60
      ? "You have spoken less than 1 minute. Speak more to get accurate results."
      : "";

  const [recording, setRecording] = useState(false);
  const [recognition, setRecognition] = useState(null);
  const [doctortranscript, setTranscript] = useState("");
  const [analysisDone, setAnalysisDone] = useState(false);
  // Generate a unique patient ID when component loads
  const generatePatientId = () => {
    // Check if session ID exists from questionnaire
    const sessionId = localStorage.getItem('sessionId');
    if (sessionId) {
      return sessionId;
    }
    return `PAT-${Date.now()}`;
  };

  const [id, setId] = useState(generatePatientId()); // Initialize with a generated ID
  const [patientname, setName] = useState("");
  const [age, setAge] = useState("");
  const [culturalBackground, setCulturalBackground] = useState("");
  const [positiveWords, setPositiveWords] = useState([]);
  const [language, setLanguage] = useState("original");
  const [translationEngine, setTranslationEngine] = useState('deepl');
  const [speechLanguage, setSpeechLanguage] = useState('hi-IN');
  const [speechTips, setSpeechTips] = useState(false);
  const [micStatus, setMicStatus] = useState('inactive'); // inactive, active, error
  const [translatedContent, setTranslatedContent] = useState({});


  // Update speech language when engine changes
  useEffect(() => {
    if (translationEngine === 'azure') {
      setSpeechLanguage('hi-IN');
    } else {
      setSpeechLanguage('en-US');
    }
    // Stop current recording when engine changes
    if (recording && recognition) {
      recognition.stop();
      setRecording(false);
      stopTimer();
    }
  }, [translationEngine]);
  const location = useLocation();
  const patient = location.state?.patient;

  const API_BASE_URL = process.env.NODE_ENV === "production"
    ? (process.env.REACT_APP_PROD_API_BASE_URL || "https://test.conversationaily.ai")
    : (process.env.REACT_APP_DEV_API_BASE_URL || "https://testone.conversationaily.ai");
  const navigate = useNavigate();
  const casereview = () => {
    navigate("/casereview");
  };

  const doctortrancscriptionSection = useRef(null);
  const reportRef = useRef(null);
  const detailedReportRef = useRef(null);

  const [isDownloading, setIsDownloading] = useState(false);

  const downloadDetailedReportPDF = async () => {
    if (!detailedReportRef.current) return;

    try {
      setIsDownloading(true);

      const canvas = await html2canvas(detailedReportRef.current, {
        scale: 2,
        useCORS: true,
        scrollY: -window.scrollY,
        windowWidth: document.body.scrollWidth,
        windowHeight: document.body.scrollHeight
      });

      // ✅ MOVE EVERYTHING BELOW INSIDE try
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = pageWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save(`Detailed_Discourse_Report_${id || "report"}.pdf`);

      // ✅ Delay + redirect
      setTimeout(() => {
        setIsDownloading(false);
        window.open("https://forms.gle/vQs19YcRWHo6GqVm8", "_blank");
      }, 2500);

    } catch (error) {
      console.error("Download failed:", error);
      setIsDownloading(false);
    }
  };

  const handleLanguageChange = async (event) => {
    const selectedLang = event.target.value;
    setLanguage(selectedLang);

    if (selectedLang === 'hi' || selectedLang === 'kn') {
      await translateContent(selectedLang);
    }
  };

  const translateContent = async (targetLang) => {
    try {
      const textsToTranslate = [
        'Try a Mock Consultation',
        'Case Summary',
        'Duration of Consultation',
        'Tone',
        'Red Flags',
        'Empathy Score'
      ];

      const translations = {};
      for (const text of textsToTranslate) {
        translations[text] = await bhashiniService.translateText(text, 'en', targetLang);
      }

      setTranslatedContent(translations);
    } catch (error) {
      console.error('Translation failed:', error);
    }
  };

  const getTranslatedText = (text) => {
    return translatedContent[text] || text;
  };


  // const toggleRecording = async () => {
  //   if (!recognition) {
  //     console.error('Recognition not initialized');
  //     return;
  //   }
  //   if (!recording) {
  //     try {
  //       console.log('Starting recording...');
  //       recognition.start();
  //       setRecording(true);
  //       startTimer();
  //       hasAnalyzedRef.current = false;
  //     } catch (error) {
  //       console.error('Failed to start recognition:', error);
  //     }
  //   } else {
  //     try {
  //       console.log('Stopping recording...');
  //       recognition.stop();
  //       setRecording(false);
  //       stopTimer();
  //       setShowSummary(true);

  //       // Process transcript after stopping
  //       setTimeout(async () => {
  //         if (!hasAnalyzedRef.current && doctortranscript.trim()) {
  //           console.log('Analyzing transcript:', doctortranscript);

  //           // Translate based on selected engine
  //           let translatedText = doctortranscript;
  //           if (translationEngine === 'azure') {
  //             try {
  //               const response = await fetch(`${API_BASE_URL}/api/translate`, {
  //                 method: 'POST',
  //                 headers: {
  //                   'Content-Type': 'application/json'
  //                 },
  //                 body: JSON.stringify({
  //                   text: doctortranscript,
  //                   engine: 'azure',
  //                   target_lang: 'en'
  //                 })
  //               });
  //               const result = await response.json();
  //               translatedText = result.translated || doctortranscript;
  //               console.log('Azure translation:', translatedText);
  //             } catch (error) {
  //               console.error('Azure translation failed:', error);
  //             }
  //           } else {
  //             // Call translate API for non-azure engines too
  //             try {
  //               const response = await fetch(`${API_BASE_URL}/api/translate`, {
  //                 method: 'POST',
  //                 headers: {
  //                   'Content-Type': 'application/json'
  //                 },
  //                 body: JSON.stringify({
  //                   text: doctortranscript,
  //                   engine: translationEngine,
  //                   target_lang: 'en'
  //                 })
  //               });
  //               const result = await response.json();
  //               translatedText = result.translated || doctortranscript;
  //               console.log('Translation result:', translatedText);
  //             } catch (error) {
  //               console.error('Translation failed:', error);
  //             }
  //           }

  //           // Analyze and save - call all APIs in sequence
  //           const empathyData = await analyzeTranscriptWithAI(translatedText);
  //           matchStigmatizingTerms(doctortranscript);
  //           await saveTranscript(doctortranscript, voiceDuration);
  //           await saveConsultationData(empathyData);

  //           hasAnalyzedRef.current = true;
  //         }
  //       }, 1000);

  //       doctortrancscriptionSection.current.scrollIntoView({ behavior: "smooth" });
  //     } catch (error) {
  //       console.error('Failed to stop recognition:', error);
  //       setRecording(false);
  //     }
  //   }
  // };


  //  const handleSaveAndGoHome = () => {
  //    const finalDuration = voiceDuration;
  //    saveTranscript(doctortranscript, finalDuration);
  //    navigate(-1);
  //  };


  const toggleRecording = async () => {
    if (!recognition || isCallEnded) {
      console.error("Recognition not initialized or call ended");
      return;
    }

    if (!recording) {
      try {
        console.log("Starting recording...");

        recognition.start();
        setRecording(true);

        startTimer();
        hasAnalyzedRef.current = false;
      } catch (error) {
        console.error("Failed to start recognition:", error);
      }
    } else {
      try {
        console.log("Pausing recording...");

        recognition.stop();
        setRecording(false);

        stopTimer();

        // Pause only
        // No summary
        // No analysis
        // No API calls
      } catch (error) {
        console.error("Failed to pause recognition:", error);
        setRecording(false);
      }
    }
  };
  const formatDuration = ({ hours, minutes, seconds }) => {
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  };

  const saveTranscript = async (transcript, duration) => {
    console.log("💾 Saving transcript:", { transcript, duration, patientId: id });
    if (!transcript || transcript.trim() === "") {
      console.warn("No transcript to save - transcript is empty");
      return;
    }

    try {
      const doctorId = parseInt(localStorage.getItem("doctorId"));
      console.log("Doctor ID being sent:", doctorId);
      const response = await axios.post(`${API_BASE_URL}/api/diabetes/save_transcription`, {
        patientId: id,
        doctor_id: doctorId,
        transcript,
        duration: {
          hours: duration.hours || 0,
          minutes: duration.minutes || 0,
          seconds: duration.seconds || 0
        }
      });
      console.log("✅ Transcript saved successfully:", response.data);
    } catch (error) {
      console.error("❌ Error saving transcript:", error.response?.data || error.message);
    }
  };
  //    try {
  //      await axios.post(`${API_BASE_URL}/api/diabetes/save_transcription`, {
  //        transcript,
  //        duration
  //      });
  //    } catch (error) {
  //      console.error("Error saving transcript:", error);
  //    }
  //  };
  const saveConsultationData = async (empathyData = null) => {
    console.log('🚨 saveConsultationData called');
    try {
      let doctorId = parseInt(localStorage.getItem("doctorId"));

      if (!doctorId) {
        doctorId = 64;
        localStorage.setItem("doctorId", "64");
        console.log('⚠️ No doctor ID found, using default:', doctorId);
      }
      console.log('👨‍⚕️ Doctor ID:', doctorId);

      const finalEmpathyData = empathyData || empathySummary;
      console.log('🧠 Empathy data:', finalEmpathyData);

      const consultationData = formatConsultationData({
        doctorId,
        patientId: id,
        speciality: extractSpeciality(patient),
        caseType: extractCaseType(patient),
        empathySummary: finalEmpathyData,
        matchedSuggestions,
        stigmatizingWords: highlightWords,
        transcript: doctortranscript,
        duration: voiceDuration
      });

      const response = await saveConsultationSession(consultationData, API_BASE_URL);
      console.log("✅ Consultation saved:", response);
      setConsultationData(response);
    } catch (error) {
      console.error("❌ Error saving consultation:", error);
      console.error("❌ Details:", error.response?.data || error.message);
    }
  };

  const analyzeTranscriptWithAI = async (text) => {
    try {
      console.log('🔍 Calling analyseempathy API at:', `${API_BASE_URL}/api/diabetes/analyseempathy`);
      console.log('📝 Transcript text:', text);
      const empathyRes = await axios.post(`${API_BASE_URL}/api/diabetes/analyseempathy`, {
        transcript: text,
      });
      console.log('✅ Analyseempathy API response:', empathyRes.data);
      const firstSummary = empathyRes.data?.[0];
      console.log("🧠 First Empathy Summary:", firstSummary);

      const tone = firstSummary?.tone;
      const redFlags = firstSummary?.redFlags || [];
      const score = firstSummary?.score ?? 0;

      const empathyData = { tone, redFlags, score };
      setEmpathySummary(empathyData);

      const matched = stigmatizingTerms.filter(termObj => {
        const term = termObj["Stigmatizing Term (English)"]?.toLowerCase();
        return term && text.toLowerCase().includes(term);
      });
      setMatchedSuggestions(matched);
      return empathyData;

    } catch (err) {
      console.error("❌ Failed to analyze empathy:", err);
      console.error("❌ Error details:", err.response?.data || err.message);
      return { tone: 'Unknown', redFlags: [], score: 0 };
    }
  };

  const [showDetailedReport, setShowDetailedReport] = useState(false);

  const gaugeData = [
    {
      name: 'Stigma',
      value: totalStigmatizingWords,
      fill: '#DC2626' // red2626' // red
    },
  ];
  const maxGaugeValue = totalWords > 0 ? totalWords : 1; // avoid division by zero

  const DetailedReportModal = () => {
    const doctorId = localStorage.getItem("doctorId") || "0012";
    const consultDuration = Math.floor((voiceDuration.hours * 60 + voiceDuration.minutes + voiceDuration.seconds / 60));

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-lg max-w-4xl max-h-[90vh] overflow-y-auto p-6" ref={detailedReportRef}>
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-[#1D3A73]">ConversationAIly™ One-Way Clinical Discourse Analysis Report</h2>
            <button
              onClick={() => setShowDetailedReport(false)}
              className="text-gray-500 hover:text-gray-700 text-2xl"
              type="button"
            >
              ×
            </button>
          </div>

          <div className="space-y-6 text-sm text-gray-800">
            <div className="grid grid-cols-2 gap-4 bg-gray-50 p-4 rounded">
              <div className="text-gray-700"><strong>Doctor ID:</strong> {doctorId}</div>
              <div className="text-gray-700"><strong>Consult ID:</strong> {id}</div>
              <div className="text-gray-700"><strong>Consult Type:</strong> One-way mock consultation</div>
              <div className="text-gray-700"><strong>Clinical Context:</strong> {patient?.Category || "General consultation"}</div>
              <div className="text-gray-700"><strong>Language:</strong> {language === 'hi' ? 'Hindi–English (code-mixed)' : 'English'}</div>
              <div className="text-gray-700"><strong>Duration:</strong> ~{consultDuration} minutes</div>
              <div className="text-gray-700"><strong>Overall Empathy Score:</strong> {empathySummary.score} / 10</div>
              <div className="text-gray-700"><strong>Dominant Communication Mode:</strong> {empathySummary.tone || 'Clinical'}</div>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-2">Scope of Analysis</h3>
              <ul className="list-disc pl-5 space-y-1">
                <li>This report evaluates the doctor's spoken discourse only in a largely one-way consultation focused on patient counselling.</li>
                <li>Analysis reflects anticipated patient perception and impact of language, not patient responses, or clinical outcomes.</li>
                <li>Domains analyzed: lexical (word) framing, sentence structure, tone and affect, speaker stance, and embedded empathy cues.</li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-2">Lexical Profile (Word Choice)</h3>
              <div className="overflow-x-auto">
                <table className="w-full border-collapse border border-gray-300">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 p-2 text-left">Lexical Category</th>
                      <th className="border border-gray-300 p-2 text-left">Observed Pattern</th>
                      <th className="border border-gray-300 p-2 text-left">Interpretation</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr><td className="border border-gray-300 p-2">Imperatives / obligation verbs</td><td className="border border-gray-300 p-2">Frequent directive language</td><td className="border border-gray-300 p-2">High directive load</td></tr>
                    <tr><td className="border border-gray-300 p-2">Risk / threat framing</td><td className="border border-gray-300 p-2">Repeated complication references</td><td className="border border-gray-300 p-2">Fear-weighted messaging</td></tr>
                    <tr><td className="border border-gray-300 p-2">Affective vocabulary</td><td className="border border-gray-300 p-2">Sparse</td><td className="border border-gray-300 p-2">Emotion named, not normalized</td></tr>
                    <tr><td className="border border-gray-300 p-2">Stigma risk</td><td className="border border-gray-300 p-2">{totalStigmatizingWords > 0 ? 'Present' : 'Minimal'}</td><td className="border border-gray-300 p-2">Needs balancing validation</td></tr>
                  </tbody>
                </table>
              </div>
              <p className="mt-2 italic">Language is directive and risk-weighted, but could benefit from more normalizing and partnership-oriented vocabulary.</p>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-2">Empathy Signal Detection</h3>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <h4 className="font-medium text-green-600">Present signals</h4>
                  <ul className="list-disc pl-5 text-sm">
                    <li>Respectful address and basic rapport</li>
                    <li>Practical support and guidance</li>
                    <li>Clear explanations</li>
                  </ul>
                </div>
                <div>
                  <h4 className="font-medium text-red-600">Absent or weak signals</h4>
                  <ul className="list-disc pl-5 text-sm">
                    {empathySummary.redFlags?.map((flag, idx) => <li key={idx}>{flag}</li>) || <li>Limited emotional exploration</li>}
                  </ul>
                </div>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-2">Empathy Score {empathySummary.score} / 10 Rationale</h3>
              <ul className="list-disc pl-5 space-y-1">
                <li>The score reflects courtesy and support within the consultation style.</li>
                <li><strong>Positive contributors:</strong> Clear communication, professional approach</li>
                <li><strong>Limiting factors:</strong> {empathySummary.redFlags?.join(', ') || 'Limited emotional signaling'}</li>
                <li><strong>Net effect:</strong> Clinically appropriate but could improve empathy signaling</li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-2">Proposed Training and Communication Refinement</h3>
              <div className="space-y-3">
                <div>
                  <h4 className="font-medium">A. Lexical Rebalancing</h4>
                  <p>Insert brief normalizing or validating phrases alongside instructions</p>
                </div>
                <div>
                  <h4 className="font-medium">B. Tone Softening Without Dilution</h4>
                  <p>Replace absolute rules with rationale-based framing</p>
                </div>
                <div>
                  <h4 className="font-medium">C. Partnership Signalling</h4>
                  <p>Use anticipatory collaboration cues in communication</p>
                </div>
              </div>
            </div>

            <div className="bg-blue-50 p-4 rounded">
              <h3 className="text-lg font-semibold mb-2">Summary Classification</h3>
              <div className="grid grid-cols-2 gap-2">
                <div>Clinical clarity: Moderate–high</div>
                <div>Language safety: Acceptable</div>
                <div>Empathy signaling: {empathySummary.score >= 7 ? 'High' : empathySummary.score >= 4 ? 'Moderate' : 'Low'}</div>
                <div>Patient-centered framing: {totalStigmatizingWords === 0 ? 'Good' : 'Needs improvement'}</div>
              </div>
            </div>

            <div className="flex justify-end mt-6">
              <button
                onClick={downloadDetailedReportPDF}
                disabled={isDownloading}
                className={`px-4 py-2 rounded-lg text-sm font-medium text-white ${isDownloading
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-green-600 hover:bg-green-700"
                  }`}
                type="button"
              >
                {isDownloading ? "Downloading..." : "Download Detailed Report"}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const matchStigmatizingTerms = (text) => {
    if (!text || !stigmatizingTerms.length) {
      setTotalWords(0);
      setTotalStigmatizingWords(0);
      return;
    }

    const lowerText = text.toLowerCase();
    const allWords = lowerText.trim().split(/\s+/).filter(word => word.length > 0);

    const matched = [];
    const matchedWords = [];

    allStigmatizingTerms.forEach(item => {
      const term = item["Stigmatizing Term (English)"]?.toLowerCase();
      if (term && lowerText.includes(term)) {
        matched.push(item);
        matchedWords.push(term);
      }
    });

    console.log('Total words:', allWords.length);
    console.log('Matched stigmatizing words:', matchedWords);
    console.log('Total stigmatizing terms available:', allStigmatizingTerms.length);
    console.log('Transcript:', text);

    setHighlightWords(matchedWords);
    setMatchedStigmatizingTerms(matched);
    setTotalWords(allWords.length);
    setTotalStigmatizingWords(matchedWords.length);
  };


  useEffect(() => {
    // Load both stigmatizing terms files
    Promise.all([
      fetch("/stigmatizing_terms.json").then(res => res.json()),
      fetch("/stigma_2_terms.json").then(res => res.json())
    ])
      .then(([originalTerms, stigma2Terms]) => {
        setStigmatizingTerms(originalTerms);
        setStigma2Terms(stigma2Terms);
        // Combine both arrays for comprehensive matching
        const combined = [...originalTerms, ...stigma2Terms];
        setAllStigmatizingTerms(combined);
      })
      .catch((err) => console.error("Failed to load stigmatizing terms:", err));
  }, []);

  useEffect(() => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) {
      console.error("Speech recognition not supported");
      return;
    }
    const newRecognition = new SpeechRecognition();
    newRecognition.continuous = true;
    //    newRecognition.interimResults = false;
    //    newRecognition.onresult = (event) => {
    //      let newTranscript = "";
    //      for (let i = event.resultIndex; i < event.results.length; i++) {
    //        if (event.results[i].isFinal) {
    //          newTranscript += event.results[i][0].transcript + " ";
    //        }
    //      }
    //      if (newTranscript.trim() !== "") {
    //        setTranscript(prev => prev + newTranscript);
    //      }
    //    };
    //    setRecognition(newRecognition);
    //
    //    return () => {
    //      newRecognition.stop();
    //    };
    //  }, []);
    newRecognition.interimResults = true;
    newRecognition.lang = speechLanguage;
    newRecognition.maxAlternatives = 1;

    let isRecognitionActive = false;

    newRecognition.onstart = () => {
      console.log('Speech recognition started');
      isRecognitionActive = true;
      setMicStatus('active');
    };

    newRecognition.onresult = (event) => {
      if (isMutedRef.current) {
        return;
      }

      let finalTranscript = "";

      for (let i = event.resultIndex; i < event.results.length; i++) {
        if (event.results[i].isFinal) {
          finalTranscript +=
            event.results[i][0].transcript + " ";
        }
      }

      console.log("Final transcript chunk:", finalTranscript);

      if (finalTranscript.trim()) {
        setTranscript(
          (prev) => prev + finalTranscript
        );
      }
    };

    newRecognition.onerror = (event) => {
      console.error('Speech recognition error:', event.error);
      isRecognitionActive = false;
      setMicStatus('error');
    };

    newRecognition.onend = () => {
      console.log("Speech recognition ended");

      setMicStatus("inactive");

      if (
        recording &&
        !isCallEndedRef.current
      ) {
        setTimeout(() => {
          try {
            newRecognition.start();
          } catch (e) {
            console.log("Restart failed:", e);
          }
        }, 500);
      }
    };

    setRecognition(newRecognition);

    return () => {
      if (newRecognition) {
        newRecognition.stop();
      }
    };
  }, [speechLanguage]);

  //            <div className="relative flex items-center" style={{ width: "240px" }}>
  //              <img src="./bhashni_logo.png" alt="Logo" className="h-8 w-8 mr-2" />
  //              <select
  //                value={language}
  //                onChange={handleLanguageChange}
  //                className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
  //              >
  //                <option value="">Choose a language</option>
  //                <option value="en">English</option>
  //                <option value="hi">Hindi</option>
  //                <option value="kn">Kannada</option>
  //              </select>
  //              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
  //                <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
  //                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.574 4.343 8 12.954 14.293z" />
  //                </svg>
  //              </div>
  //            </div>


  // const handleEndCall = async () => {
  //   try {
  //     setIsCallEnded(true);
  //     isCallEndedRef.current = true;

  //     if (recognition) {
  //       recognition.stop();
  //     }

  //     setRecording(false);
  //     stopTimer();
  //     setShowSummary(true);

  //     if (!hasAnalyzedRef.current && doctortranscript.trim()) {
  //       const empathyData = await analyzeTranscriptWithAI(
  //         doctortranscript
  //       );

  //       matchStigmatizingTerms(doctortranscript);

  //       // await saveTranscript(
  //       //   doctortranscript,
  //       //   voiceDuration
  //       // );

  //       await saveConsultationData(empathyData);

  //       hasAnalyzedRef.current = true;
  //     }
  //   } catch (error) {
  //     console.error("End Call Error:", error);
  //   }
  // };

  //   const handleEndCall = async () => {
  //   console.log("1. handleEndCall called");

  //   // Total voice duration in seconds
  //   const totalSeconds =
  //     (voiceDuration.hours || 0) * 3600 +
  //     (voiceDuration.minutes || 0) * 60 +
  //     (voiceDuration.seconds || 0);

  //   // Minimum 45 seconds required
  //   if (totalSeconds < 45) {
  //     const remainingSeconds = 45 - totalSeconds;

  //     showToast(
  //       `Minimum 45 seconds of recording is required. Please continue for ${remainingSeconds} more second${remainingSeconds !== 1 ? "s" : ""}.`
  //     );

  //     return;
  //   }

  //   try {
  //     setIsCallEnded(true);
  //     isCallEndedRef.current = true;

  //     console.log("2. Call state updated");

  //     if (recognition) {
  //       console.log("3. Stopping recognition");
  //       try {
  //         recognition.onend = null;
  //         recognition.stop();
  //       } catch (err) {
  //         console.log("Recognition stop error:", err);
  //       }
  //     }

  //     console.log("4. Recognition stopped");

  //     setRecording(false);
  //     stopTimer();

  //     console.log("5. Recording and timer stopped");

  //     setShowSummary(true);

  //     console.log("6. Summary shown");

  //     const transcript = doctortranscript?.trim();

  //     console.log("7. Transcript:", transcript);

  //     console.log("hasAnalyzedRef.current", hasAnalyzedRef.current)

  //     if (!hasAnalyzedRef.current && transcript) {
  //       console.log("8. Starting AI analysis");

  //       const empathyData = await analyzeTranscriptWithAI(transcript);

  //       console.log("9. AI analysis completed:", empathyData);

  //       matchStigmatizingTerms(transcript);

  //       console.log("10. Stigmatizing terms checked");

  //       await saveConsultationData(empathyData);

  //       console.log("11. Consultation data saved");

  //       hasAnalyzedRef.current = true;

  //       console.log("12. Analysis completed");
  //     } else {
  //       console.log(
  //         "Analysis skipped:",
  //         {
  //           alreadyAnalyzed: hasAnalyzedRef.current,
  //           transcriptExists: !!transcript,
  //         }
  //       );
  //     }

  //     console.log("13. handleEndCall completed");
  //   } catch (error) {
  //     console.error("End Call Error:", error);
  //   }
  // };

  const handleEndCall = async () => {
    console.log("1. handleEndCall called");

    // Total voice duration in seconds
    const totalSeconds =
      (voiceDuration.hours || 0) * 3600 +
      (voiceDuration.minutes || 0) * 60 +
      (voiceDuration.seconds || 0);

    // Minimum 90 seconds required
    if (totalSeconds < 90) {
      const remainingSeconds = 90 - totalSeconds;

      // toast.error(
      //   `Minimum 90 seconds of recording is required. Please continue for ${remainingSeconds} more second${remainingSeconds !== 1 ? "s" : ""}.`
      // );

      Swal.fire({
        title: "Consultation too short",
        text: `You need to speak for at least 90 seconds before ending. Please continue for ${remainingSeconds} second${remainingSeconds !== 1 ? "s" : ""}.`,
        icon: "warning",
        confirmButtonText: "Continue",
        confirmButtonColor: "#1D3A73",
        allowOutsideClick: false,
        allowEscapeKey: false,
      });


      return;
    }

    try {
      setIsCallEnded(true);
      isCallEndedRef.current = true;

      console.log("2. Call state updated");

      if (recognition) {
        console.log("3. Stopping recognition");

        try {
          recognition.onend = null;
          recognition.stop();
        } catch (err) {
          console.log("Recognition stop error:", err);
        }
      }

      console.log("4. Recognition stopped");

      setRecording(false);
      stopTimer();

      console.log("5. Recording and timer stopped");

      setShowSummary(true);

      console.log("6. Summary shown");

      const transcript = doctortranscript?.trim();

      console.log("7. Transcript:", transcript);

      console.log(
        "hasAnalyzedRef.current",
        hasAnalyzedRef.current
      );

      if (!hasAnalyzedRef.current && transcript) {
        console.log("8. Starting AI analysis");

        const empathyData = await analyzeTranscriptWithAI(transcript);

        console.log("9. AI analysis completed:", empathyData);

        matchStigmatizingTerms(transcript);

        console.log("10. Stigmatizing terms checked");

        await saveConsultationData(empathyData);

        console.log("11. Consultation data saved");

        hasAnalyzedRef.current = true;

        console.log("12. Analysis completed");
      } else {
        console.log("Analysis skipped:", {
          alreadyAnalyzed: hasAnalyzedRef.current,
          transcriptExists: !!transcript,
        });
      }

      console.log("13. handleEndCall completed");
    } catch (error) {
      console.error("End Call Error:", error);
    }
  };

  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex-1 z-10">


        <CaseReviewNavbar name={name} />

        <DashboardHeader />

      </div>
      <div className="relative isolate px-6 lg:px-8 py-2">
        <div className="mx-auto flex justify-between items-center">
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-2">
              <label className="text-sm font-medium text-gray-700">Engine:</label>
              <select
                value={translationEngine}
                onChange={(e) => setTranslationEngine(e.target.value)}
                disabled={recording}
                className="px-3 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 bg-white disabled:bg-gray-100"
              >
                <option value="deepl">International Language</option>
                <option value="azure">Indian Languages</option>
              </select>
            </div>
            <div className="flex items-center space-x-2">
              <label className="text-sm font-medium text-gray-700">Speech:</label>
              <select
                value={speechLanguage}
                onChange={(e) => {
                  setSpeechLanguage(e.target.value);
                  setSpeechTips(e.target.value === 'hi-IN');
                }}
                disabled={recording}
                className="px-3 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 bg-white disabled:bg-gray-100"
              >
                {translationEngine === 'azure' ? (
                  <>
                    <option value="hi-IN">Hindi (India)</option>
                    <option value="en-IN">English (India)</option>
                    <option value="kn-IN">Kannada (India)</option>
                    <option value="ta-IN">Tamil (India)</option>
                    <option value="te-IN">Telugu (India)</option>
                    <option value="bn-IN">Bengali (India)</option>
                    <option value="gu-IN">Gujarati (India)</option>
                    <option value="mr-IN">Marathi (India)</option>
                    <option value="pa-IN">Punjabi (India)</option>
                    <option value="ur-IN">Urdu (India)</option>
                  </>
                ) : (
                  <>
                    <option value="en-US">English (US)</option>
                    <option value="en-GB">English (UK)</option>
                    <option value="de-DE">German</option>
                    <option value="fr-FR">French</option>
                    <option value="es-ES">Spanish</option>
                    <option value="it-IT">Italian</option>
                    <option value="pt-PT">Portuguese (PT)</option>
                    <option value="pt-BR">Portuguese (Brazil)</option>
                    <option value="nl-NL">Dutch</option>
                    <option value="pl-PL">Polish</option>
                    <option value="ru-RU">Russian</option>
                    <option value="ja-JP">Japanese</option>
                    <option value="zh-CN">Chinese (Simplified)</option>
                    <option value="ko-KR">Korean</option>
                    <option value="id-ID">Indonesian</option>
                    <option value="tr-TR">Turkish</option>
                    <option value="uk-UA">Ukrainian</option>
                  </>
                )}
              </select>
              {speechTips && (
                <div className="ml-2 text-xs text-blue-600 bg-blue-50 px-2 py-1 rounded">
                  💡 Speak clearly in Hindi for better accuracy
                </div>
              )}
            </div>
          </div>
          <button
            onClick={() => navigate(-1)}
            className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded text-sm font-medium"
          >
            ← Back
          </button>
        </div>
      </div>
      <br />
      <div className="min-h-screen font-sans text-gray-800 flex flex-col items-center">
        {/* Consultation Prompt Section */}
        <div className="bg-[#1D3A73] text-white w-full py-10 px-4 md:px-10 flex flex-col items-center">
          <div className="bg-white text-[#1D3A73] px-4 py-2 rounded-md flex items-center justify-center text-sm font-medium w-full max-w-3xl mb-4">
            <img src="./consult/images/layer_174.png" alt="doc icon" className="h-8 mr-2" />
            {patient?.Category || "Geriatrics"} – {patient?.["Case Type"] || "Dementia Denial"}
          </div>

          <p className="text-sm text-white mb-4 max-w-3xl text-left">
            {patient?.["Clinical Data"] || "Increasing forgetfulness. Son reports wandering episodes. Patient denies anything is wrong."}
          </p>

          <div className="grid grid-cols-2 md:grid-cols-2 gap-x-6 gap-y-2 text-sm font-semibold text-white max-w-2xl mb-4 w-full">
            <div className="flex justify-between">
              <span>FPG:</span><span>{patient?.FPG || "N/A"}</span>
            </div>
            <div className="flex justify-between">
              <span>PPG:</span><span>{patient?.PPG || "N/A"}</span>
            </div>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-2 gap-x-6 gap-y-2 text-sm font-semibold text-white max-w-2xl mb-4 w-full">
            <div className="flex justify-between">
              <span>HbA1c:</span><span>{patient?.HbA1c || "N/A"}</span>
            </div>
            <div className="flex justify-between">
              <span>BMI:</span><span>{patient?.BMI || "N/A"}</span>
            </div>
          </div>

          <div className="italic text-white text-center text-sm max-w-2xl mb-6">
            <img src="./consult/images/layer_192.png" alt="quote icon" className="inline-block h-8 mr-2" />
            <span className="text-white font-semibold">
              {language === "hi"
                ? (patient?.["Patient Quote (India-centric)"] || "मुझे समझ नहीं आता कि सभी मेरी इतनी चिंता क्यों कर रहे हैं।")
                : (patient?.["Patient Quote (English)"] || "I don't understand why everyone is so worried about me.")}
            </span>
          </div>

          <div className="bg-[#F7941D] text-black px-4 py-3 w-full max-w-3xl rounded-md text-center">
            <p className="text-sm font-medium">
              → {patient?.["Consult Prompt"] || "How would you approach this consultation with empathy while addressing the family's concerns about the patient's cognitive decline?"}
            </p>
          </div>

          <DoctorRecordingControls
            recording={recording}
            toggleRecording={toggleRecording}
            voiceDuration={voiceDuration}
            formatDuration={formatDuration}
            //                  handleSaveAndGoHome={handleSaveAndGoHome}
            translationEngine={translationEngine}
            speechLanguage={speechLanguage}
            micStatus={micStatus}
            handleEndCall={handleEndCall}
            isMuted={isMuted}
            toggleMute={toggleMute}
            isCallEnded={isCallEnded}
            doctortranscript={doctortranscript}
          />

          <div ref={doctortrancscriptionSection} class="text-black px-6 py-6 w-full max-w-3xl rounded-md text-center">
            <DoctorTranscriptionSection
              transcript={doctortranscript}
              setTranscript={setTranscript}
              highlightWords={highlightWords}
              redFlagAlternatives={matchedStigmatizingTerms}
            />
          </div>
          {showSummary && (
            <div className="flex flex-col sm:flex-row gap-6 justify-center mt-4" style={{ paddingBottom: "2rem" }}>

              <div className="flex justify-center flex-wrap gap-6 mb-10">
                {/* Case Summary */}
                <div className="bg-white border border-[#1D3A73]/20 rounded-2xl px-6 py-6 shadow-lg hover:shadow-xl transition-all duration-300 w-[320px]">
                  <div className="flex items-center mb-4">
                    {/* <img src="./doctor/images/layer_179.png" alt="summary icon" className="h-6 mr-2" /> */}
                    <h3 className="text-xl font-bold text-[#1D3A73]">{getTranslatedText('Case Summary')}</h3>
                  </div>

                  <p className="text-sm text-[#1D3A73] mb-1">
                    <strong>{getTranslatedText('Duration of Consultation')}:</strong> {formattedSpokenTime}
                  </p>

                  {spokenTimeWarning && (
                    <p className="text-xs text-orange-500 mt-1 italic">{spokenTimeWarning}</p>
                  )}
                  <p className="text-sm text-[#1D3A73] mb-1"><strong>{getTranslatedText('Tone')}:</strong> {empathySummary.tone || "N/A"}</p>
                  <p className="text-sm text-[#1D3A73] mb-1"><strong>{getTranslatedText('Red Flags')}:</strong> {empathySummary.redFlags?.join(", ") || "None"}</p>
                  <p className="text-sm text-[#1D3A73] mb-3"><strong>{getTranslatedText('Empathy Score')}:</strong> {empathySummary.score ?? "N/A"}</p>
                  <p className="text-sm text-[#1D3A73] mb-2"><strong>Suggesting Terms:</strong></p>
                  <ul className="list-disc pl-5 text-sm text-[#1D3A73]/90 space-y-1">
                    {matchedSuggestions.length > 0 ? matchedSuggestions.map((item, idx) => (
                      <li key={idx}>
                        <span className="font-medium">"{item["Stigmatizing Term (English)"]}"</span>{" "}
                        → <em>"{item["Person-Centered Alternative (English)"]}"</em>{" "}
                        <span className="text-orange-500 font-medium">(Severity: {item["Severity"] || "Unknown"})</span>
                      </li>
                    )) : <li>No suggestions found</li>}
                  </ul>
                </div>

                <div className="bg-white border border-[#1D3A73]/20 rounded-2xl px-6 py-6 shadow-lg hover:shadow-xl transition-all duration-300 w-[320px]">
                  <div className="flex items-center mb-4">
                    {/* <img src="./doctor/images/layer_180.png" alt="flag icon" className="h-6 mr-2" /> */}
                    <div>
                      <h4 className="text-xl font-bold text-[#1D3A73]">Used Stigmatizing Words</h4>
                      <p className="text-sm text-gray-600">
                        {totalStigmatizingWords} out of {totalWords} words
                      </p>

                    </div>
                  </div>

                  <div className="relative w-full h-[140px] mb-4">
                    <ResponsiveContainer width="100%" height="100%">
                      <RadialBarChart
                        cx="50%"
                        cy="50%"
                        innerRadius="80%"
                        outerRadius="100%"
                        barSize={12}
                        data={gaugeData}
                        startAngle={180}
                        endAngle={0}
                      >
                        <PolarAngleAxis
                          type="number"
                          domain={[0, maxGaugeValue]}
                          angleAxisId={0}
                          tick={false}
                        />
                        <RadialBar
                          minAngle={15}
                          background
                          clockWise
                          dataKey="value"
                          cornerRadius={10}
                        />
                      </RadialBarChart>
                    </ResponsiveContainer>

                    {/* Center Label */}
                    <div className="absolute inset-0 flex items-center justify-center text-[#1D3A73] font-bold text-sm">
                      {totalStigmatizingWords} / {totalWords}
                    </div>
                  </div>
                  {/* Word List */}
                  <ul className="list-disc pl-5 text-sm text-red-600 space-y-1 mt-4">
                    {highlightWords.length > 0
                      ? highlightWords.map((word, i) => <li key={i}>{word.charAt(0).toUpperCase() + word.slice(1)}</li>)
                      : <li className="text-[#1D3A73]">None detected</li>}
                  </ul>
                </div>
              </div>
            </div>
          )}

          {/* Discourse Analysis Report */}
          {showSummary && doctortranscript && (
            <div>
              <DiscourseAnalysisReport
                ref={reportRef}
                transcript={doctortranscript}
                patientId={id}
                doctorId={localStorage.getItem("doctorId")}
                durationSeconds={voiceDuration.hours * 3600 + voiceDuration.minutes * 60 + voiceDuration.seconds}
                clinicalContext={patient?.Category || "General consultation"}
                empathyScore={empathySummary.score}
                consultationData={consultationData}
              />
              <div className="flex justify-center mt-4 gap-4">
                <button
                  onClick={() => setShowDetailedReport(true)}
                  className="bg-[#1D3A73] hover:bg-[#2a4a8a] text-white px-6 py-2 rounded-lg font-medium transition-colors"
                  type="button"
                >
                  Read More
                </button>
              </div>
            </div>
          )}

          {/* Detailed Report Modal */}
          {showDetailedReport && <DetailedReportModal />}
        </div>

        {/* Footer */}
        <div className="text-center py-10 bg-white w-full">
          <h3 className="text-xl font-bold text-[#1D3A73] mb-2">Want more?</h3>
          <p className="text-sm mb-6">
            After your first trial, explore the full <span className="text-[#F7941D] font-semibold">ConversationAlly</span> platform:
          </p>
          <div className="flex justify-center flex-wrap gap-6 mb-6">
            {["./doctor/images/layer_179.png", "./doctor/images/layer_180.png", "./doctor/images/layer_181.png"].map((img, i) => (
              <div
                key={i}
                className="bg-[#1D3A73] border border-white rounded-2xl px-6 py-6 flex flex-row items-center w-[200px] text-white"
              >
                <img src={img} alt="feature icon" className="h-10 mb-2" />
                <p className="text-sm text-center">
                  {i === 0 && "Longitudinal feedback"}
                  {i === 1 && "Multi-language cue libraries"}
                  {i === 2 && "Custom reports for clinics"}
                </p>
              </div>
            ))}
          </div>
          <FooterSection />
        </div>
      </div>
    </div>
  );
}

export default ConsultationPrompt;



// const matchStigmatizingTerms = (text) => {
//   const lowerText = text.toLowerCase();
//   const matched = stigmatizingTerms.filter(item =>
//     lowerText.includes(item["Stigmatizing Term (English)"].toLowerCase())
//   );
//   const matchedWords = matched.map(item => item["Stigmatizing Term (English)"].toLowerCase());
//   setHighlightWords(matchedWords);

//   setMatchedStigmatizingTerms(matched);
// };

{/* Case Summary Box */ }
{/* <div className="border rounded-md p-4 shadow w-full sm:w-[300px]">
                    <div className="flex items-center space-x-2 mb-2">
                      <h3 className="font-semibold text-gray-800">Case Summary</h3>
                    </div>
                    <p><strong>Tone:</strong> {empathySummary.tone || "N/A"}</p>
                    <p><strong>RED FLAGS:</strong> {empathySummary.redFlags?.join(", ") || "None"}</p>
                    <p><strong>EMPATHY SCORE:</strong> {empathySummary.score ?? "N/A"}</p>
                    <div className="mt-2">
                      <p className="font-medium text-sm">Suggesting Terms</p>
                      <ul className="list-disc pl-5 text-sm">
                        {matchedSuggestions.length > 0 ? matchedSuggestions.map((item, idx) => (
                          <li key={idx}>
                            <span className="text-gray-700">
                              "{item["Stigmatizing Term (English)"]}"
                            </span>{" "}
                            → <em>"{item["Person-Centered Alternative (English)"]}"</em>{" "}
                            <span className="text-red-600">(Severity: {item["Severity"] || "Unknown"})</span>
                          </li>
                        )) : <li>No suggestions found</li>}
                      </ul>
                    </div>
                  </div> */}

{/* Used Stigmatizing Words Box */ }
{/* <div className="border p-4 rounded-md w-full sm:w-[300px]">
                    <h4 className="font-semibold mb-2 text-red-700">Used Stigmatizing Words</h4>
                    <ul className="list-disc pl-5 text-sm text-red-600">
                      {highlightWords.map((word, i) => <li key={i}>{word}</li>)}
                    </ul>
                  </div> */}

{/* Used Stigmatizing Words */ }
{/* <div className="bg-white border border-[#1D3A73]/20 rounded-2xl px-6 py-6 shadow-lg hover:shadow-xl transition-all duration-300 w-[320px]">
                    <div className="flex items-center mb-4">
                      <img src="./doctor/images/layer_180.png" alt="flag icon" className="h-6 mr-2" />
                      <div>
                        <h4 className="text-xl font-bold text-[#1D3A73]">Used Stigmatizing Words</h4>
                        <p className="text-sm text-gray-600">
                          {totalStigmatizingWords} out of {totalWords} words
                        </p>
                      </div>
                    </div>
                    <ul className="list-disc pl-5 text-sm text-red-600 space-y-1">
                      {highlightWords.length > 0
                        ? highlightWords.map((word, i) => <li key={i}>{word}</li>)
                        : <li className="text-[#1D3A73]">None detected</li>}
                    </ul>
                  </div> */}

// <div className="flex justify-center flex-wrap gap-6 mb-6">
//   {/* Case Summary */}
//   <div className="bg-[#1D3A73] border border-white bg-white rounded-2xl px-6 py-6 flex flex-col items-start w-[300px] text-[#1D3A73]">
//     <div className="flex items-center mb-3">
//       <img src="./doctor/images/layer_179.png" alt="summary icon" className="h-6 mr-2" />
//       <h3 className="text-lg font-semibold">Case Summary</h3>
//     </div>
//     <p className="text-sm"><strong>Tone:</strong> {empathySummary.tone || "N/A"}</p>
//     <p className="text-sm"><strong>RED FLAGS:</strong> {empathySummary.redFlags?.join(", ") || "None"}</p>
//     <p className="text-sm mb-3"><strong>EMPATHY SCORE:</strong> {empathySummary.score ?? "N/A"}</p>
//     <p className="text-sm font-semibold mb-1">Suggesting Terms:</p>
//     <ul className="list-disc pl-5 text-sm">
//       {matchedSuggestions.length > 0 ? matchedSuggestions.map((item, idx) => (
//         <li key={idx}>
//           <span className="text-[#1D3A73]">
//             "{item["Stigmatizing Term (English)"]}"
//           </span>{" "}
//           → <em>"{item["Person-Centered Alternative (English)"]}"</em>{" "}
//           <span className="text-orange-400">(Severity: {item["Severity"] || "Unknown"})</span>
//         </li>
//       )) : <li>No suggestions found</li>}
//     </ul>
//   </div>

//   {/* Used Stigmatizing Words */}
//   <div className="bg-[#1D3A73] border border-white bg-white rounded-2xl px-6 py-6 flex flex-col items-start w-[300px] text-[#1D3A73]">
//     <div className="flex items-center mb-3">
//       <img src="./doctor/images/layer_180.png" alt="flag icon" className="h-6 mr-2" />
//       <h4 className="text-lg font-semibold text-[#1D3A73]">Used Stigmatizing Words</h4>
//     </div>
//     <ul className="list-disc pl-5 text-sm text-red">
//       {highlightWords.length > 0
//         ? highlightWords.map((word, i) => <li key={i}>{word}</li>)
//         : <li>None detected</li>}
//     </ul>
//   </div>
// </div>